import { useEffect, useCallback, useRef } from "react";

export default function SlideUpNow({children, delay=0, top=100}){

  const ref = useRef();

  const appear = useCallback(()=>{
    setTimeout(()=>{
      ref.current?.classList.add(`slideUp`)
      setTimeout(()=>{
        ref.current?.classList.remove('opacity-0');
        ref.current?.classList.remove(`translate-y-[30%]`)
      }, 2900)
    }, delay);
  },[delay]);

  useEffect(()=>{
    setTimeout(()=> appear(), delay);
  },[appear, delay]);

  return (
    <div ref={ref} className={`opacity-0 translate-y-[30%]`}>
      {children}
    </div>
  );

}